import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { createAdminFetch, type AdminFetchDeps } from './admin-fetch';

/**
 * The dedicated Admin Relay environment: an in-memory record store fed by the
 * Entra-token-injecting fetch. Kept separate from the vault's Relay environment
 * — different token source, no per-vault header, no offline persistence.
 */
export function createAdminRelayEnvironment(deps: AdminFetchDeps): Environment {
    return new Environment({
        network: Network.create(createAdminFetch(deps)),
        store: new Store(new RecordSource()),
    });
}
